import type { RouteRecordRaw } from "vue-router";
import { routeNames } from "@/router/constants";
import { config, envIsDemoPreProd } from "@/config";
import { useIntl } from "@moroku/money-webapp-components";
import { UserProfileSection } from "@/features/User/constants.ts";

const { t } = useIntl();

export const getBaseRoutes = (): RouteRecordRaw[] => [
  {
    path: "/",
    name: routeNames.HOME,
    component: () => import("@/features/User/HomeView.vue"),
    meta: {
      title: t("home_title"),
    },
  },
  {
    path: "/profile-error",
    name: routeNames.CUSTOMER_ERROR_VIEW,
    component: () => import("@/features/User/CustomerErrorView.vue"),
    meta: {
      requiresAuth: false,
      title: t("error_title"),
    },
  },
  {
    path: "/messages",
    name: routeNames.MESSAGES,
    component: () => import("@/features/User/MessagesView.vue"),
    meta: {
      title: t("messages_title"),
    },
  },

  {
    path: "/profile",
    name: routeNames.USER_PROFILE,
    component: () => import("@/features/User/UserProfileView.vue"),
    props: () => ({ tab: UserProfileSection.PersonalDetails }),
    meta: {
      title: t("profile_title"),
      headerBottomMargin: false,
    },
  },
  {
    path: "/security",
    name: routeNames.SECURITY_VIEW,
    component: () => import("@/features/User/UserProfileView.vue"),
    props: () => ({ tab: UserProfileSection.Security }),
    meta: {
      title: t("security_title"),
      headerBottomMargin: false,
    },
  },
  {
    path: "/app-preferences",
    name: routeNames.APP_PREFERENCES,
    component: () => import("@/features/User/UserProfileView.vue"),
    props: () => ({ tab: UserProfileSection.InternetBankingPrefs }),
    meta: {
      title: t("appPreferences_title"),
      headerBottomMargin: false,
    },
  },
  {
    path: "/sign-in",
    name: routeNames.SIGN_IN_VIEW,
    component: () => import("@/features/User/SignInView.vue"),
    props: () => ({ isSignIn: true }),
    meta: {
      requiresAuth: false,
      title: t("onboarding_authentication_web_signIn_title"),
    },
  },
  {
    path: "/sign-up",
    name: routeNames.SIGN_UP_VIEW,
    component: () => import("@/features/User/SignInView.vue"),
    props: () => ({ isSignIn: false }),
    meta: {
      requiresAuth: false,
      title: t("onboarding_authentication_web_signUp_title"),
    },
    beforeEnter: () => {
      if (!config.signUpEnabled) {
        return { name: routeNames.SIGN_IN_VIEW };
      }
    },
  },
  {
    path: "/theme-manager",
    name: routeNames.THEME_MANAGER,
    component: () => import("@/features/core/ThemeManagerView.vue"),
    beforeEnter: () => {
      // Check variant for Moroku Money as well when that has been added to the config
      if (!envIsDemoPreProd) {
        return { name: routeNames.PAGE_NOT_FOUND };
      }
    },
    meta: {
      requiresInternalUser: true,
      title: t("themeManager_title"),
    },
  },
  {
    path: "/update-mobile",
    name: routeNames.UPDATE_MOBILE_NUMBER,
    component: () => import("@/features/User/UpdateMobileNumberView.vue"),
    meta: {
      title: t("profile_updateMobile_title"),
    },
  },
];
